import styled from "styled-components"

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    vertical-align: top;
    flex-direction: column;
`